import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/page-header'
import { LedgerAuditLookupSection } from '@/features/ledger/audit-lookup'

/**
 * The audit trail lookup, as an addressable screen of its own.
 *
 * Gated on `ops.audit.view`, which is an operations permission rather than a ledger one — so a
 * `ledger.journal.view` holder may reach this screen and be unable to use it, which the panel says
 * plainly rather than showing an empty result.
 */
export function LedgerAuditPage() {
  return (
    <>
      <Link
        to="/ledger"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-text hover:text-brand-text-hover max-lg:min-h-11 max-lg:py-2"
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        All of the ledger
      </Link>

      <PageHeader
        title="Ledger audit trail"
        description="Who acted on a ledger record, and whether anybody countersigned it. A journal carries an identifier; the trail carries the name."
      />

      <LedgerAuditLookupSection />
    </>
  )
}
